<template>
  <div
    class="upload-container"
    @drop.prevent="handleFileDrop"
    @dragover.prevent="dragover"
    @dragleave.prevent="dragleave"
    @mouseover="getCartItemAttachments()"
  >
    <div
      v-if="randomID"
      :id="`cartitem-${cartItemID}`"
      :class="uploadCellClass"
      @click="$refs.file.click()"
    >
      <strong class="mr-1">{{ filecount }}&nbsp;</strong>
      <span v-if="currentStatus !== 1" :for="randomID"
        ><i class="fas fa-upload mt-2"></i
      ></span>
      <span v-if="currentStatus === 1"
        ><i class="fas fa-spinner fa-spin mt-2"></i
      ></span>
      <input
        :id="randomID"
        ref="file"
        type="file"
        multiple
        :name="uploadFieldName"
        :disabled="isSaving"
        hidden
        accept=".jpg,.png,.pdf,.stl,.psd,.ai,.xls,.xlsx,.csv,.xlsm"
        class="input-file"
        @change="
          filesChange($event.target.name, $event.target.files);
          fileCount = $event.target.files.length;
        "
      />
      <b-popover
        :target="`cartitem-${cartItemID}`"
        triggers="hover"
        placement="top"
      >
        <template #title>{{ $t("uploadedFiles") }}</template>

        <span v-if="files.length === 0">{{ $t("noFilesUploaded") }}</span>
        <ul>
          <li v-for="file in files" :key="file.cartAttachmentID">
            {{ file.fileName }}
          </li>
        </ul>
      </b-popover>
    </div>
    <div
      v-if="filecount > 0"
      class="delete-files text-danger"
      @click="deleteCartItemAttachments()"
    >
      <i class="fas fa-trash"></i>
    </div>
  </div>
</template>
<script>
// your vue component
import {
  deleteCartItemAttachments,
  getCartItemAttachments,
  uploadFileToCartItem,
} from "../../services/cart";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: "VueExcelCellUpload",
  // access any cell properties here
  props: {
    cell: {
      type: Object,
      required: true,
    },
    row: {
      type: Array,
      required: true,
    },
    record: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      randomID: "",
      currentStatus: null,
      uploadFieldName: "files",
      file: null,
      files: [],
      filecount: 0,
      uploadCellClass: {"upload-cell": true},
      initialHover: false,
    };
  },
  computed: {
    cartItemID() {
      return this.record.cartItemID;
    },
    value() {
      return this.record[this.cell.name];
    },
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
  },
  created() {
    this.randomID = `upload-label${Math.floor(Math.random() * 101333333)}`;
    this.filecount = this.value;
  },
  methods: {
    async deleteCartItemAttachments() {
      await deleteCartItemAttachments({cartItemID: this.cartItemID});
      this.files = 0;
      this.filecount = 0;
      this.$toasted.show(
        "All uploaded attachments for the selected row have been discarded",
      );
    },
    async getCartItemAttachments(override = false) {
      if (this.initialHover === true && override === false) return;
      this.initialHover = true;
      this.files = await getCartItemAttachments({cartItemID: this.cartItemID});
    },
    dragover: function () {
      this.uploadCellClass = {
        "upload-cell": true,
        "upload-cell-hover": "true",
      };
    },
    dragleave: function () {
      this.uploadCellClass = {
        "upload-cell": true,
      };
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
      this.uploadCellClass = {
        "upload-cell": true,
      };
    },
    async save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      let result = null;
      try {
        result = await uploadFileToCartItem({
          cartItem: {cartItemID: this.record.cartItemID},
          formData,
        });
      } catch (error) {
        if (error.response.data.Message === "Maximum request length exceeded.")
          this.$toasted.show(
            this.$t(
              "The file you are trying to upload is to large, files may not exceed 10 MB",
            ),
          );
        this.reset();
        return;
      }
      this.getCartItemAttachments(true);

      this.$toasted.show(result.message);

      this.filecount += result.fileCount;

      this.reset();
    },
    handleFileDrop(e) {
      let droppedFiles = e.dataTransfer.files;

      // loop over droppedFiles and check if object contains ".zip" or ".rar" or ".7zip" on name property
      for (let i = 0; i < droppedFiles.length; i++) {
        if (
          droppedFiles[i].name.includes(".zip") ||
          droppedFiles[i].name.includes(".rar") ||
          droppedFiles[i].name.includes(".7zip")
        ) {
          this.$toasted.show(
            `Uploading archives is not supported, please upload the individual files`,
          );
          this.reset();
          return;
        }
      }

      if (!droppedFiles) return;
      this.filesChange("files", droppedFiles);
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((x) => {
        formData.append(fileList[x].name, fileList[x], fileList[x].name);
      });

      // save it
      this.save(formData);
      this.fileoverclass = {};
    },
    mounted() {
      this.reset();
    },
  },
};
</script>
<style scoped>
.upload-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  pointer: cursor;
}
.delete-files {
  cursor: pointer;
}
.upload-cell {
  text-align: right;
}
label {
  color: #262a63;
  padding: 0rem;
  font-family: "Foco", sans-serif;
  border-radius: 0rem;
  cursor: pointer;
}
.upload-cell-hover {
  background-color: #cacaca;
  color: #262a63;
}
</style>
